<div id="help-panel" class="wrapper">
  <div
    *ngIf="html"
    class="content"
    id="info-content"
    [innerHtml]="html | sanitizeHtml"
  ></div>
  <div *ngIf="!html" class="content1">
    <h3 style="background-image: url('/assets/img/tools/help.png')">
      MapPort Help
    </h3>
    <p>
      Move around the map with the mouse. Click and drag to move the screen, and
      use the scroll wheel to zoom in or out.
    </p>
    <p>
      Use tools to interact with the map. Change tools with the buttons in the
      top left corner. Hold the mouse over each button for a description of what
      that tool does.
    </p>
    <p>
      If a tool has options, you can see and set those in this panel, on the
      left. If you're interacting with things on the map, their details will
      show up in a similar panel on the right.
    </p>
    <p>Want to find something quickly? Use the search bar in the top right.</p>
    <p>Enjoy using MapPort!</p>
  </div>
</div>

<div>
  <a class="closer button">
    <img
      (click)="closeRightpanel()"
      [tooltip]="mapService.templatetoolTips['close_right_panel']"
      [options]="myClose"
      class="closer-img"
      src="/assets/img/tools/close-pv3.png"
      alt="closer"
  /></a>
</div>
